// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"223":"home-page","358":"earn","402":"alpha-scanner","712":"base-mint","942":"not-found","966":"dashboard"}[chunkId] + "." + {"223":"e95dcb1e","358":"b7b93f0f","402":"46b7d03f","712":"82118fae","942":"33032e70","966":"4122a96b"}[chunkId] + ".chunk.css";
};